export const DELETE_SUCCESS = 'Фотография удалена';
export const DELETE_ERROR = 'Не удалось удалить фотографию';
